(() => {
  'use strict';
  const openDialog = dialog => { if(dialog && !dialog.open) dialog.showModal(); };
  const closeDialog = dialog => { if(dialog?.open) dialog.close(); };
  document.addEventListener('click', event => {
    if (event.target.closest('.search-open')) openDialog(document.getElementById('SearchDialog'));
    const close = event.target.closest('.dialog-close');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target instanceof HTMLDialogElement) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target);
    }
    if (event.target.closest('.mobile-menu a')) document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', event => {
    if(event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  const setupProduct = section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const form = section.querySelector('.purchase-form');
    const buttons = [...section.querySelectorAll('[data-purchase-button]')];
    const quantity = form?.querySelector('[name="quantity"]');
    const error = section.querySelector('[data-purchase-error]');
    const select = form?.querySelector('[data-variant-select]');
    let busy = false;
    let available = buttons.some(button => !button.disabled);
    const refreshButtons = () => buttons.forEach(button => {
      button.disabled = busy || !available;
      button.querySelector('[data-button-label]').textContent = !available ? section.dataset.soldOut : button.dataset.availableLabel;
    });
    const syncQuantityButtons = () => {
      if (!quantity) return;
      const count = Number(quantity.value), min = Number(quantity.min || 1);
      section.querySelectorAll('[data-quantity-change]').forEach(button => {
        button.disabled = busy || (Number(button.dataset.quantityChange) < 0 ? count <= min : !!quantity.max && count >= Number(quantity.max));
      });
    };
    const setImage = (url, alt) => {
      const image = section.querySelector('.pdp-image');
      if (!image || !url) return;
      image.removeAttribute('srcset');
      image.src = url;
      if (alt) image.alt = alt;
      section.querySelectorAll('.pdp-thumbnail').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageUrl === url)));
    };
    section.addEventListener('click', event => {
      const stepper = event.target.closest('[data-quantity-change]');
      if (stepper && quantity && !busy) {
        if (Number(stepper.dataset.quantityChange) > 0) quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', {bubbles: true}));
      }
      const thumbnail = event.target.closest('.pdp-thumbnail');
      if (thumbnail) setImage(thumbnail.dataset.imageUrl, thumbnail.dataset.imageAlt);
    });
    quantity?.addEventListener('input', syncQuantityButtons);
    quantity?.addEventListener('change', syncQuantityButtons);
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      available = option.dataset.available === 'true';
      section.querySelectorAll('[data-product-price]').forEach(price => {price.textContent = option.dataset.price;});
      const compare = section.querySelector('[data-compare-price]');
      compare.hidden = !option.dataset.compare;
      compare.textContent = option.dataset.compare || '';
      const stock = section.querySelector('[data-product-stock]');
      stock.textContent = available ? section.dataset.inStock : section.dataset.soldOut;
      stock.classList.toggle('is-unavailable', !available);
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      }
      if (error) error.hidden = true;
      setImage(option.dataset.imageUrl);
      refreshButtons(); syncQuantityButtons();
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
    });
    form?.addEventListener('submit', async event => {
      if (event.submitter && !event.submitter.matches('[data-purchase-button]')) return;
      event.preventDefault();
      if (busy || !available || !form.reportValidity()) return;
      const buyNow = !!event.submitter?.matches('[data-buy-now]');
      const payload = new FormData(form);
      payload.delete('return_to');
      busy = true;
      form.setAttribute('aria-busy', 'true');
      error.hidden = true;
      refreshButtons(); syncQuantityButtons();
      if (select) select.disabled = true;
      if (quantity) quantity.readOnly = true;
      if (event.submitter) event.submitter.querySelector('[data-button-label]').textContent = section.dataset.busyLabel;
      try {
        const endpoint = new URL(form.action);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
        const response = await fetch(endpoint, {method:'POST', body:payload, credentials:'same-origin', headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : section.dataset.errorMessage);
        location.assign(buyNow ? section.dataset.checkoutUrl : section.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message === 'Failed to fetch' ? section.dataset.errorMessage : failure.message || section.dataset.errorMessage;
        error.hidden = false;
        error.focus();
        busy = false;
        form.removeAttribute('aria-busy');
        if (select) select.disabled = false;
        if (quantity) quantity.readOnly = false;
        refreshButtons(); syncQuantityButtons();
      }
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      busy = false;
      form?.removeAttribute('aria-busy');
      if (select) select.disabled = false;
      if (quantity) quantity.readOnly = false;
      refreshButtons(); syncQuantityButtons();
    });
    syncQuantityButtons();
  };
  document.querySelectorAll('[data-product-section]').forEach(setupProduct);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-product-section]').forEach(setupProduct));
  if (!window.ELMKHBAZ_PREVIEW) return;
  const preview = window.ELMKHBAZ_PREVIEW;
  const badge = document.createElement('span'); badge.className = 'preview-mode'; badge.textContent = 'معاينة التصميم'; document.body.appendChild(badge);
  const dialog = document.createElement('dialog'); dialog.className = 'preview-dialog'; dialog.setAttribute('aria-label','معاينة المنتج');
  dialog.innerHTML = '<button type="button" class="icon-button dialog-close" aria-label="اقفل المعاينة">×</button><div class="preview-dialog-content"></div>';
  document.body.appendChild(dialog);
  const content = dialog.querySelector('.preview-dialog-content');
  const showProduct = key => { const product = preview.products[key]; if(product?.url) location.assign(product.url); };
  document.addEventListener('click', event => {
    const card = event.target.closest('[data-product-preview]');
    if(card){ event.preventDefault(); showProduct(card.dataset.productPreview); }
    if(event.target.closest('.cart-link')){ event.preventDefault(); location.assign(preview.cartUrl); }
  });
  document.querySelectorAll('.search-form').forEach(form => form.addEventListener('submit', event => {
    event.preventDefault();
    const query = new FormData(form).get('q').toString().trim();
    let results=form.parentElement.querySelector('.preview-search-results');
    if(!results){results=document.createElement('div');results.className='preview-search-results';form.after(results);}
    results.replaceChildren();
    const normalize = str => str.normalize('NFKD').replace(/[\u064B-\u065F]/g,'').replace(/[أإآ]/g,'ا').toLowerCase();
    const matches=Object.entries(preview.products).filter(([,p])=>normalize(p.title+' '+p.keywords).includes(normalize(query)));
    if(!matches.length){ const p=document.createElement('p');p.textContent='مفيش نتائج بالاسم ده. جرّب عيش، توست أو فينو.';results.appendChild(p); }
    for(const [key,p] of matches){const btn=document.createElement('button');btn.type='button';const img=new Image();img.src=p.image;img.alt='';const span=document.createElement('span');span.textContent=p.title;btn.append(img,span);btn.addEventListener('click',()=>{closeDialog(form.closest('dialog'));showProduct(key);});results.appendChild(btn);}
  }));
})();
